// How each status reads on the vehicle diagram and in its legend. Status colors are fixed, not the brand's: they
// have to mean the same thing on every program's portal. Serviced, due and declined differ in lightness and pattern
// as well as hue (dark blue fill / light amber with a dashed edge / orange hatch), so they stay apart for color-blind
// members and in grayscale. `line` is the solid color for parts drawn as strokes (wipers), which can't take a fill or
// a hatch; due's line is a darker amber than its fill so a thin stroke still shows.
export const STATUS = {
  serviced: {
    fill: '#1F5FA8',
    stroke: 'none',
    dash: null,
    line: '#1F5FA8',
    label: 'Serviced in the last 6 months',
    heading: 'SERVICED RECENTLY',
    color: '#1F5FA8',
  },
  due: {
    fill: '#F2B544',
    stroke: '#7A4E00',
    dash: '4 3',
    line: '#C98A12',
    label: 'Due by mileage or time',
    heading: 'DUE',
    color: '#7A4E00',
  },
  declined: {
    // Drawn with the diagram's own hatch pattern (each diagram has its own pattern id): `stroke` lines on `tint`.
    hatch: true,
    fill: null,
    tint: '#F8D9C8',
    stroke: '#C2410C',
    dash: null,
    line: '#C2410C',
    label: 'Recommended, you declined',
    heading: 'YOU DECLINED',
    color: '#A33509',
  },
};

// The "Past due" chip on a due item.
export const PAST_DUE_CHIP = { color: '#5C3B00', bgcolor: '#FCE7B8' };

export const STATUS_ORDER = ['serviced', 'due', 'declined'];

// Where each part's number badge sits on the 240 x 480 top-down outline.
export const BADGE_POSITIONS = {
  engine_oil: [120, 138],
  engine_air_filter: [85, 70],
  battery: [157, 70],
  engine_performance: [120, 109],
  cooling: [120, 12],
  lights: [72, 12],
  // Off-center on the cowl: centered, it would sit on the engine oil badge at the hood's edge.
  cabin_air_filter: [166, 158],
  wipers: [120, 190],
  climate: [91, 235],
  drivetrain: [120, 290],
  tires: [31, 50],
  brakes: [209, 152],
  alignment: [31, 152],
};

// Where a due item's date came from, in words a member understands.
export const DUE_SOURCES = {
  oem: 'Manufacturer schedule',
  next_service: 'Recommended by your shop',
  repeat_transaction_calculator: 'Based on your visits',
  vehicle: 'From your last oil change',
};
